import { _IMAPI } from "../assets/js/imapi";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import action from "../redux/action"

const useGetBalance = () => {

    const dispatch = useDispatch();

    const fetchBalance = (setLoader) => {

        setLoader((pre) => {
            return { ...pre, loading: true }
        })
        _IMAPI._GET(_IMAPI.getService('wallet'), {}, {}, (res) => {

          

            setLoader((pre) => {
                return { ...pre, loading: false }
            })
            dispatch(action.accountBalance(res.data));

        }, (err) => {

            setLoader((pre) => {
                return { ...pre, loading: false }
            })

            if (err) {
                let data = err.response ? err.response.data : err;
                toast.error(data.message)
            } else {

            }
        })

    }

    return { fetchBalance }



}

export default useGetBalance